module.exports = __webpack_public_path__ + "static/media/Card3.3fe53265.png";